module.exports = __webpack_public_path__ + "img/Penguin.76394d25.png";